import React from "react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import { FormikFormGroup, ModalSubmit } from "components/common";
import { Alert, Modal, Row, Col } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
import useRepositoryFormErrors from "./hooks/useRepositoryFormErrors";
const KNOWN_FIELDS = ["name", "location"];
const FileSystemRepositoryModalForm = ({ hideModal }) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const { fsPaths, onCreateRepository } = useRepositories(void 0, { fetchFsPaths: true });
  const { formError, clearFormError, applyBackendErrors } = useRepositoryFormErrors(KNOWN_FIELDS);
  const buildOptions = () => {
    var _a;
    return ((_a = fsPaths.data) != null ? _a : []).map((fsPath) => ({
      value: fsPath,
      label: fsPath
    }));
  };
  const handleSubmit = (values, { setErrors }) => {
    clearFormError();
    return onCreateRepository({ type: "fs", ...values }).then(() => hideModal()).catch((error) => applyBackendErrors(error, setErrors));
  };
  const initialValues = {
    name: "",
    location: ""
  };
  const validate = (values) => {
    var _a, _b;
    const errors = {};
    if (!((_a = values.name) == null ? void 0 : _a.trim())) errors.name = t("repository_form.name_required");
    if (!((_b = values.location) == null ? void 0 : _b.trim())) errors.location = t("file_system.location_required");
    return errors;
  };
  return /* @__PURE__ */ React.createElement(
    Formik,
    {
      onSubmit: handleSubmit,
      initialValues,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, formError && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, formError), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "text",
        label: t("repository_form.name"),
        name: "name",
        help: t("repository_form.name_help"),
        required: true
      }
    ), fsPaths.isLoading ? t("file_system.fetching_locations") : fsPaths.data && /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        type: "select",
        key: "location",
        name: "location",
        label: t("file_system.location"),
        required: true,
        help: t("file_system.location_help")
      },
      /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("option", { key: "placeholder", value: "" }, t("file_system.location_placeholder")), buildOptions().map(({ value, label }) => /* @__PURE__ */ React.createElement("option", { key: value, value }, label)))
    )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: t("repository_form.create"),
        submitLoadingText: t("repository_form.creating"),
        onCancel: hideModal,
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  );
};
export default FileSystemRepositoryModalForm;
